import { Helmet } from "react-helmet"

import Layout from "../components/layout/Layout"
import About1 from "../components/sections/About1"
import Achivements from "../components/sections/Achivements"
import Brand1 from "../components/sections/Brand1"
import Team2 from "../components/sections/Team2"
import Testimonial1 from "../components/sections/Testimonial1"
import VisionMission from "../components/sections/VisionMission"
export default function About() {
	return (
		<>
			<Helmet>
				<title>About Us | V-Make WPC Doors & Frames</title>
				<meta name="description" content="Learn more about V-Make – a trusted name in WPC door and frame manufacturing. Discover our journey, commitment to quality, sustainability, and innovation." />
				<meta name="keywords" content="About V-Make, WPC manufacturer, WPC doors company, eco-friendly doors, sustainable WPC, door frame manufacturer, interior door specialists, WPC innovation, company mission, WPC production" />
				<link rel="canonical" href="https://vmakewpc.com/about" />
				<meta property="og:title" content="About Us | V-Make WPC" />
				<meta property="og:description" content="V-Make is a leading manufacturer of premium WPC doors and frames, committed to delivering sustainable, stylish, and long-lasting solutions for modern spaces." />
				<meta property="og:url" content="https://vmakewpc.com/about" />
				<meta
					property="og:image"
					content="https://vmakewpc.com/assets/img/about/About.jpg"
				/>
				<meta property="og:type" content="website" />
				<meta property="og:updated_time" content="2024-12-02T00:00:00+00:00" />
				<meta property="article:modified_time" content="2024-12-02T00:00:00+00:00" />
			</Helmet>
			<Layout headerStyle={1} footerStyle={1} breadcrumbTitle="About">
				<About1 />
				<VisionMission />
				{/* <Achivements />	 */}
				<Testimonial1 />
				<Team2 alt />
				{/* <Brand1 /> */}
			</Layout>
		</>
	)
}
